module.exports = __webpack_public_path__ + "static/img/arrow-down.38f5e2c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/arrow-down.gif
// module id = chVj
// module chunks = 47